import AppSummaryPage from 'pages/AppSummary';
import EditPagePage from 'pages/EditPage';
import EditMenuPage from 'pages/EditMenu';
import EditMenuItemDependenciesPage from 'pages/EditMenuItemDependencies';
import EditSectionAttributesPage from 'pages/EditSectionAttributes';
import EditSectionPage from 'pages/EditSection';
import UniversalPage from 'pages/Universal';
import AssetsPage from 'pages/Assets';
import EditAssetPage from 'pages/EditAsset';
import DashboardPage from 'pages/DashboardPage';
import LocaleManagementPage from 'pages/LocaleManagement';

const routes = [
  {
    name: 'AppSummary',
    route: '/app/:appId',
    component: <AppSummaryPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditPage',
    route: '/app/:appId/page/:pageId?',
    component: <EditPagePage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditMenu',
    route: '/app/:appId/menu/:menuId',
    component: <EditMenuPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditMenuItemDependency',
    route: '/app/:appId/menu/:menuId/menu-item-dependency/:menuItemDependencyId?/:action?',
    component: <EditMenuItemDependenciesPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditSection',
    route: '/app/:appId/page/:pageId/section/:sectionId?',
    component: <EditSectionPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditSection',
    route: '/section-attributes/:sectionId',
    component: <EditSectionAttributesPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'Assets',
    route: '/assets/',
    component: <AssetsPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditAsset',
    route: '/assets/edit/:fileId',
    component: <EditAssetPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'Dashboard',
    route: '/dashboard',
    component: <DashboardPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'EditLocales',
    route: '/locales',
    component: <LocaleManagementPage />,
    required: {
      auth: true,
    },
  },
  {
    name: 'Universal',
    route: '*',
    component: <UniversalPage />,
  },
];

export default routes;
